module.exports = __webpack_public_path__ + "static/media/businessicon.02c25d2e.svg";